// VCard.js
import React from 'react';
import ContactInfo from './ContactInfo';
import styles from "./VCFViewer.module.css";

/**
 * Converts lowercase ß to uppercase ẞ (capital sharp S)
 * This preserves the ß character when text-transform: uppercase is applied
 * @param {string} text - The text to process
 * @returns {string} Text with ß replaced by ẞ
 */
const prepareForUppercase = (text) => {
    if (!text) return text;
    // Replace lowercase ß (U+00DF) with uppercase ẞ (U+1E9E)
    return text.replace(/ß/g, 'ẞ');
};

const VCard = ({ contact }) => {
    return (
        <div className={styles.card}>
            {/* QR Code Placeholder */}
            <div className={styles.qrContainer}>
                <img
                    src="/mip-logo.png"
                    alt="mip Consult GmbH"
                />
            </div>

            {/* Contact Details */}
            <div className={styles.details}>
                <div className={styles.mipHighlight}>
                    <h2 className={styles.name}>{contact.fn && contact.fn.value ? prepareForUppercase(contact.fn.value) : 'No name given'}</h2>
                    <p className={styles.role}>{contact.org && contact.org.value ? contact.org.value.department : 'No organisation given'} {contact.role && contact.role.value ? contact.role.value : ''}</p>
                </div>

                <div className={styles.contactInfo}>
                    {contact.tel && <ContactInfo type="tel" info={contact.tel} />}
                    {contact.email && <ContactInfo type="email" info={contact.email} />}
                    {contact.url && <ContactInfo type="url" info={contact.url} />}
                    {contact.adr && <ContactInfo type="adr" info={contact.adr} />}
                </div>
            </div>
        </div>
    );
};

export default VCard;